import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import { NavLink } from "react-router-dom";
// import { MotionScene, SharedElement, MotionScreen, useMotion } from 'react-motion-layout'
// import aboutPic from '../assets/graphic.webp'
// import aboutPic from '../assets/graphic-1.jpg'

export default function About() {

    const [scrolled, setscrolled] = useState('0vw')
    const [read, setread] = useState('100vw')
    const [scrolledR, setscrolledR] = useState('-100vw')
    const [scrollOp, setscrollOp] = useState(1)
    const [intro, setintro] = useState('-100vw')

    const handleScroll = () => {
        let scroll = window.scrollY
        let vh = window.innerHeight
        if (scroll > (2 * vh) / 1.5) {
            setscrolled('-100vw')
            setscrolledR('-100vw')
            setscrollOp(0)
            setread('200vw')
            setintro('0vw')
        } else if (scroll < (vh) / 2) {
            setscrolled('-100vw')
            setscrolledR('-110vw')
            setread('-200vw')
            setscrollOp(0)
            setintro('0vw')
        } else {
            setscrolled('-60vw')
            setscrolledR('0vw')
            setscrollOp(.1)
            setread('-5vw')
            setintro('-100vw')
        }
    }

    // const history = useHistory();
    // const withTransition = useMotion('about-pic');
    // const callback = useCallback(() => history.push('/about'), [
    //     history
    // ]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])
    return (
        <div className="page" id="about">
            <div className="about-intro">
                <motion.h1
                    initial={{ x: '100vw', opacity: 0 }}
                    animate={{ x: scrolledR, opacity: 1 }}
                    transition={{ ease: "easeOut", duration: .5 }}>
                    DEVELOPER
                </motion.h1>
                <motion.p
                    initial={{ x: '100vw', opacity: 0 }}
                    animate={{ x: scrolledR, opacity: 1 }}
                    transition={{ ease: "easeOut", duration: .6 }}>
                    web / apps
                </motion.p>
            </div>
            <NavLink to="/about" >
                <motion.div
                    className="about-card">
                    {/* <MotionScreen>
                    <MotionScene name="about-pic">
                        <SharedElement.Image
                            id="about-pic"
                            alt="graphic"
                            duration=".8"
                            src={aboutPic}
                            animationKey="image"
                        />
                    </MotionScene>
                </MotionScreen > */}
                    {/* <div id="about-pic"></div> */}
                    <motion.div id="intro"
                        initial={{ x: '0vw' }}
                        animate={{ x: intro }}
                        transition={{ ease: 'easeIn', duration: .5, }} />
                    <motion.div id="intro-bl"
                        initial={{ x: '0vw' }}
                        animate={{ x: intro }}
                        transition={{ ease: 'easeOut', duration: .3 }} />
                    {/* <div className="graphic"></div> */}
                    <motion.div
                        initial={{ x: '100vw', y: '-10vw', opacity: 0 }}
                        animate={{ x: '-50vh', y: '-10vw', opacity: scrollOp }}
                        transition={{ ease: "easeOut", duration: .9 }}
                        className="bg-about">ABOUT ME</motion.div>
                    <motion.div
                        initial={{ x: '-100px', opacity: 0 }}
                        animate={{ x: scrolledR, opacity: 1 }}
                        transition={{ ease: "easeOut", duration: .9 }}
                        className="about-top-card"
                    >
                        ABOUT ME
                </motion.div>
                    <motion.div
                        initial={{ x: '100vw', opacity: 0 }}
                        animate={{ x: read, opacity: 1 }}
                        transition={{ ease: "easeOut", duration: .9 }}
                        className="read-more"
                    // onClick={withTransition(callback)}
                    >
                        SEE MORE <span className="fa fa-long-arrow-right a-icon"></span>
                    </motion.div>
                </motion.div>
            </NavLink>
        </div>
    )
}
